import { useTranslation } from 'react-i18next';
import { dayFormatter } from './format';
import { todayIn } from './range';
import type { Stats } from './stats';

export interface Trend {
    labels: string[];
    orders: number[];
    revenue: number[];
    /** One point per hour when the range is a single day, otherwise one per day. */
    hourly: boolean;
}

/** Orders and revenue over time: hourly for one day, daily otherwise. */
export const useTrend = (stats: Stats): Trend => {
    const { i18n } = useTranslation();
    if (stats.range.days === 1) {
        const { timezone, from } = stats.range;
        // Hours that have not happened yet are left out instead of being drawn as zero.
        const now = new Date();
        const hourNow = Number(new Intl.DateTimeFormat('en-GB', { timeZone: timezone, hour: '2-digit', hourCycle: 'h23' }).format(now));
        const hours = from === todayIn(timezone, now) ? stats.byHour.filter((h) => h.hour <= hourNow) : stats.byHour;
        return {
            hourly: true,
            labels: hours.map((h) => `${h.hour}:00`),
            orders: hours.map((h) => h.orders),
            revenue: hours.map((h) => h.revenue),
        };
    }
    const day = dayFormatter(i18n.language, { day: 'numeric', month: 'short' });
    return {
        hourly: false,
        labels: stats.daily.map((d) => day(d.date)),
        orders: stats.daily.map((d) => d.orders),
        revenue: stats.daily.map((d) => d.revenue),
    };
};
